import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import {formatToExponential} from "../../../../helpers/NumberHelper";

const defaultIndicators = {
    current: "---",
    pressure: "---"
};

export default function GammaVacuumSPCeReadBack({pipe, data}) {
    const indicators = data
        ? Object.assign(defaultIndicators, {
            current: data["current"] || defaultIndicators.current,
            pressure: data["pressure"] || defaultIndicators.pressure
        }) : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                    <Grid item>
                        <TextField
                            id="current"
                            label="Current"
                            value={formatToExponential(indicators.current)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="pressure"
                            label="Pressure"
                            value={formatToExponential(indicators.pressure)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                </Grid>
            }
        />
    );
}